var map = {
	"./pages/articulos/articulos.module": [
		"./src/app/pages/articulos/articulos.module.ts",
		"pages-articulos-articulos-module"
	],
	"./pages/error/error.module": [
		"./src/app/pages/error/error.module.ts",
		"pages-error-error-module"
	],
	"./pages/inicio/inicio.module": [
		"./src/app/pages/inicio/inicio.module.ts",
		"default~pages-inicio-inicio-module~pages-panel-de-control-novedad-novedad-module~pages-panel-de-cont~53c12c2e",
		"common",
		"pages-inicio-inicio-module"
	],
	"./pages/login/login.module": [
		"./src/app/pages/login/login.module.ts"
	],
	"./pages/panel-de-control/inicio/inicio.module": [
		"./src/app/pages/panel-de-control/inicio/inicio.module.ts",
		"pages-panel-de-control-inicio-inicio-module"
	],
	"./pages/panel-de-control/novedad/novedad.module": [
		"./src/app/pages/panel-de-control/novedad/novedad.module.ts",
		"default~pages-inicio-inicio-module~pages-panel-de-control-novedad-novedad-module~pages-panel-de-cont~53c12c2e",
		"default~pages-panel-de-control-novedad-novedad-module~pages-panel-de-control-novedadNueva-novedadNue~fa3b4da2",
		"common",
		"pages-panel-de-control-novedad-novedad-module"
	],
	"./pages/panel-de-control/novedadNueva/novedadNueva.module": [
		"./src/app/pages/panel-de-control/novedadNueva/novedadNueva.module.ts",
		"default~pages-inicio-inicio-module~pages-panel-de-control-novedad-novedad-module~pages-panel-de-cont~53c12c2e",
		"default~pages-panel-de-control-novedad-novedad-module~pages-panel-de-control-novedadNueva-novedadNue~fa3b4da2",
		"common",
		"pages-panel-de-control-novedadNueva-novedadNueva-module"
	],
	"./pages/panel-de-control/novedades/novedades.module": [
		"./src/app/pages/panel-de-control/novedades/novedades.module.ts",
		"default~pages-inicio-inicio-module~pages-panel-de-control-novedad-novedad-module~pages-panel-de-cont~53c12c2e",
		"common",
		"pages-panel-de-control-novedades-novedades-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;